<template>
    <div style="width: 100%; margin: 15px">
        <span class="md-display-2" style="margin-top: 20px"
            >Server Settings</span
        >
        <md-divider style="margin-bottom: 5px" />
        <ServerSettingRow
            v-for="setting in settings"
            :key="setting.name"
            :settingName="setting.name"
            :settingType="setting.type"
            :initialValue="setting.currentValue"
            :settingEndpoint="setting.endpoint"
            :possibleValues="setting.possibleValues"
            :description="setting.description"
            @updatedSetting="updateSettings"
        />
    </div>
</template>

<script>
import axiosMixin from "../mixins/axiosMixin";
import ServerSettingRow from "../components/ServerSettingRow.vue";

export default {
    components: {
        ServerSettingRow,
    },
    mixins: [axiosMixin],
    data() {
        return {
            settings: [],
        };
    },
    methods: {
        updateSettings() {
            this.makeRequest(
                "get",
                process.env.VUE_APP_SERVER_URL + "settings"
            ).then((resp) => {
                if (resp.status == 200) {
                    this.settings = resp.data.settings;
                }
            });
        },
    },
    mounted() {
        this.updateSettings();
    },
};
</script>

<style scoped>
</style>